<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Area</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">

    <div class="form-group">
      <label for="nameInput">Name</label>
      <input id="nameInput" type="text" class="form-control" name="name"
             required
             [(ngModel)]="locationArea.name">
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>

    <div class="form-group">
      <label for="capacityInput">Capacity</label>
      <input id="capacityInput" type="number" class="form-control" name="capacity"
             required min="0" max="1000" step="1"
             [(ngModel)]="locationArea.capacity">
      <div class="form-text text-danger">{{ errors.capacity }}</div>
    </div>

    <div class="form-group">
      <label for="allow_only_one_booked_event">
        Restrict area to one booked event at a time
      </label>
      <select class="custom-select"
              id="allow_only_one_booked_event"
              name="allow_only_one_booked_event"
              [(ngModel)]="locationArea.allow_only_one_booked_event">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
      <small class="form-text text-muted">
        If set to "Yes", any time an event in this area is booked, any other events in this area with overlapping times
        will be automatically cancelled.
      </small>
      <div class="form-text text-danger">{{ errors.allow_only_one_booked_event }}</div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
